<nav
  id="mobile-footer"
  class="nav nav-justified fixed-bottom shadow d-md-none gpt-4"
>
  <a
    [routerLink]="dashboardUrl"
    [class.active]="isActive(dashboardUrl)"
    [gptDataTrack]="'mobile-footer-dashboard'"
    class="nav-item d-flex flex-column align-items-center"
  >
    <i
      [ngClass]="
        isActive(dashboardUrl) ? 'gpicon-dashboard-filled' : 'gpicon-dashboard'
      "
    ></i>
    <span class="rl3-regular text-secondary">
      {{ 'DASHBOARD.TITLE' | translate }}
    </span>
  </a>

  <a
    href="javascript:void(0)"
    routerLink="/results"
    class="nav-item d-flex flex-column align-items-center"
    [class.active]="isActive(resultsUrl)"
    [gptDataTrack]="'mobile-footer-results'"
  >
    <i
      [ngClass]="
        isActive(resultsUrl) ? 'gpicon-results-filled' : 'gpicon-results'
      "
    ></i>
    <span class="rl3-regular text-secondary">
      {{ 'RESULTS.TITLE' | translate }}
    </span>
  </a>

  <a
    href="javascript:void(0)"
    routerLink="/add-data"
    class="nav-item d-flex flex-column align-items-center"
    [class.active]="isActive(addDataUrl)"
    [gptDataTrack]="'mobile-footer-add-data'"
  >
    <i
      [ngClass]="
        isActive(addDataUrl) ? 'gpicon-close-filled' : 'gpicon-add-data'
      "
    ></i>
    <span class="rl3-regular text-secondary">
      {{ 'RESULTS.MENU.ADD.TITLE' | translate }}
    </span>
  </a>

  @if ('shop' | isFeatureActive) {
    <div
      class="nav-item d-flex flex-column align-items-center justify-content-center"
      [class.active]="isActive(cartUrl)"
    >
      <gps-cart-count-badge
        icon="gpicon-cart-2"
        badgeClass="p6-semibold"
        [activeIcon]="
          isActive(cartUrl) ? 'gpicon-cart-2-filled' : 'gpicon-cart-2'
        "
        [gptDataTrack]="'mobile-footer-cart'"
      >
        <span class="d-block rl3-regular text-secondary">
          {{ 'SHOP.TITLE' | translate }}
        </span>
      </gps-cart-count-badge>
    </div>
  }
</nav>
